var _style, _circle, _path, _g, _polygon, _path2, _circle2, _path3, _g2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{fill:url(#SVGID_7_);}\r\n\t.st8{fill:url(#SVGID_8_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 490,
    height: 490,
    xlinkHref: "4EB35C11.png",
    transform: "matrix(0.24 0 0 0.24 -266.0958 16.68)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -316.9708,
    y1: 125.0826,
    x2: -263.8252,
    y2: 178.2283,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.3482 181.3146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C728A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -214.2,
    cy: 68.6,
    r: 43.7
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -216.8942,
    y1: 130.4357,
    x2: -288.7684,
    y2: 137.764,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.3482 181.3146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55BEC0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-130.2,90.3l-21.7-21.7c-2.2-2.2-5.7-2.5-8.1-0.5c-1.3,1.2-2,2.8-2,4.4c0,1.5,0.6,3,1.7,4.1l13.3,13.3l-54,0 c-10,6.1-23.4,4.6-31.7-4.6c-8.5-9.4-8.7-23.8-0.4-33.4c0,0,0,0,0,0l-6.5-6.5c-5.6,6.2-9.1,14.5-9,23.6 c0.1,19.2,16.1,34.6,35.3,34.6l64.5,0l-11.5,11.5c-2.3,2.3-2.3,6.1,0.1,8.4c2.3,2.1,6.1,1.9,8.3-0.3l21.6-21.6 C-127.1,98.5-127.1,93.5-130.2,90.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 335,
    height: 336,
    xlinkHref: "4EB35C13.png",
    transform: "matrix(0.24 0 0 0.24 -247.3758 35.16)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -214.2,
    cy: 68.5,
    r: 25.2
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -224.2574,
    y1: 59.579,
    x2: -198.1987,
    y2: 85.6377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C728A"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-209.9,60.2 -209.9,57.6 -206.5,57.6 -207.4,56 -206.5,54.2 -210.4,54.2 -210.4,54.2 -210.8,54.2  -210.8,60.2 -215.4,66.6 -220.2,63.2 -230,77 -197.6,77  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5,
    y1: 75,
    x2: 147.5,
    y2: 75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#EB5F26"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75,147.5C35,147.5,2.5,115,2.5,75C2.5,35,35,2.5,75,2.5c40,0,72.5,32.5,72.5,72.5 C147.5,115,115,147.5,75,147.5z M75,5.3C36.6,5.3,5.3,36.6,5.3,75c0,38.4,31.2,69.7,69.7,69.7c38.4,0,69.7-31.2,69.7-69.7 C144.7,36.6,113.4,5.3,75,5.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 490,
    height: 490,
    xlinkHref: "4EB35C16.png",
    transform: "matrix(0.24 0 0 0.24 1.8 16.68)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -127.5381,
    y1: -64.3501,
    x2: -74.3924,
    y2: -11.2044,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.3482 181.3146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#EB5F26"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 53.7,
    cy: 68.6,
    r: 43.7
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.7758,
    y1: 85.3432,
    x2: 132.2499,
    y2: 85.3432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCE32"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M137.6,90.3L116,68.7c-2.2-2.2-5.7-2.5-8.1-0.5c-1.3,1.2-2,2.8-2,4.4c0,1.5,0.6,3,1.7,4.1L120.8,90l-54,0 c-10,6.1-23.4,4.6-31.7-4.6C26.6,76,26.4,61.6,34.7,52c0,0,0,0,0,0l-6.5-6.5c-5.6,6.2-9.1,14.5-9,23.6 c0.1,19.2,16.1,34.6,35.3,34.6l64.5,0l-11.5,11.5c-2.3,2.3-2.3,6.1,0.1,8.4c2.3,2.1,6.1,1.9,8.3-0.3l21.6-21.6 C140.8,98.5,140.8,93.5,137.6,90.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 335,
    height: 336,
    xlinkHref: "4EB35C17.png",
    transform: "matrix(0.24 0 0 0.24 20.52 35.16)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 53.7,
    cy: 68.5,
    r: 25.2
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.1122,
    y1: 69.1653,
    x2: 55.4635,
    y2: 69.1653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#EB5F26"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.3,66c-1.8,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2C55.5,67.4,54,66,52.3,66z  M51.8,69.5c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9C52.7,69.1,52.3,69.5,51.8,69.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.0022,
    y1: 69.8567,
    x2: 68.9565,
    y2: 69.8567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#EB5F26"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M53,61.9c-8.8,0-16,7.9-16,7.9s7.2,7.9,16,7.9c8.8,0,16-7.9,16-7.9S61.8,61.9,53,61.9z M53,76.2 c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3C59.3,73.3,56.5,76.2,53,76.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.3e488be7040e17d4ff7f7acfd08da90b.svg";
export { ForwardRef as ReactComponent };